import { Center } from 'component/base/Grid';
import ModuleLoadingFailed, {
  IModuleLoadingFailed,
} from 'component/ui/ErrorBoundaries/ModuleLoadingFailed';
import React, { Suspense } from 'react';

import ContentLoading from '../ContentLoading';

export const spinnerLoadingElement = (
  <Center>
    <ContentLoading height="calc(100%)" />
  </Center>
);

interface SuspenseLoaderProps {
  fallback?: JSX.Element;
}

/**
 * Wraps child with React.Suspense with a spinner loader fallback, and the
 * ModuleLoadingFailed errorboundary.
 *
 * @param children Component wrapped by this boundary
 * @param filePath file path the component
 * @param publicPath the url path on which the component renders (if known)
 */
const SuspenseLoader = ({
  children,
  filePath,
  publicPath,
  fallback = spinnerLoadingElement,
}: IModuleLoadingFailed & SuspenseLoaderProps): JSX.Element => {
  return (
    <ModuleLoadingFailed filePath={filePath} publicPath={publicPath}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </ModuleLoadingFailed>
  );
};

export default SuspenseLoader;
